import ApiService from "./api";
import store from "@/store";

const Qualify = {
    get(market, locale, params = null) {
        return ApiService.get(`qualification/${market}/${locale}`, {params: params});
    },
    getProducts(postDatas, params) {
        const country = store.state.settings.country;
        let finalParams = params;
        if(country && params.country === undefined)
            finalParams = {...params, country: country};
        console.log(postDatas)
        return ApiService.post('qualification/solutions', postDatas, {params: finalParams});
    },

    /* -- Qualification construction -- */
    getApplications(params = null) {
        return ApiService.get(`applications`, {params: params});
    },
};

export default Qualify;
